<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <div class="container">
        <div class="area_wrap">
          <div class="aw_blank">
            <span class="imgWrap"><img src="@/assets/images/thanq_logo.png"/></span>
            <p>비밀번호 변경이 완료되었습니다.</p>
            <p>로그인 후 사용하시기 바랍니다.</p>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
        <button type="button" @click.prevent="goLogin()">로그인</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '비밀번호 찾기',
        prevUrl: '/passwordFindCertifyNext'
      },
      setCount: false
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  methods: {
    goLogin () {
      this.$router.push('/login')
    },
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('identity', [
      'SET_IDENTITY_SUCCESS'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/login')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  computed: {
    ...mapGetters([
      'GET_ID'
    ]),
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ])
  },
  created () {
    /* url 직접 접근 막기 */
    if (this.getReferrer.includes('isTemp') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
    this.SET_REFERRER('')
    const userInfo = {
      name: '',
      birthDate: '',
      gender: '',
      mobileno: '',
      dupInfo: ''
    }
    this.SET_IDENTITY_SUCCESS(userInfo)
  }
}
</script>

<style lang="scss" scoped>
</style>
